module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/87f635ef624114368d5c5489d8472821.png";